import PropTypes from "prop-types";
import { forwardRef, useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import IconChevronDown from "components/shared/svg/IconChevronDown";
import Checkbox from "components/shared/checkbox/Checkbox";

import {
    OptionStyled,
    Info,
    Content,
    Text,
    CheckboxContainer,
    Icon,
    Value
} from "./Option.styled";

const OptionWithValue = forwardRef(({ id, title, children, disabled }, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    const { register, setValue, watch } = useFormContext();
    const value = watch(id);

    function handleOpen(event) {
        event.preventDefault();
        event.stopPropagation();
        if (!value && !isOpen) setValue(id, true, { shouldDirty: true });
        setIsOpen(!isOpen);
    }

    useEffect(() => {
        if (!value) {
            setIsOpen(false);
        }
    }, [value, setIsOpen]);

    return (
        <OptionStyled active={value} open={isOpen} ref={ref}>
            <Info disabled={disabled}>
                <CheckboxContainer>
                    <Checkbox
                        type="checkbox"
                        id={id}
                        name={id}
                        defaultChecked={value}
                        ref={register}
                        disabled={disabled}
                    />
                </CheckboxContainer>
                <Content onClick={handleOpen}>
                    <Text>{title}</Text>
                    <Icon>
                        <IconChevronDown />
                    </Icon>
                </Content>
            </Info>
            <Value active={isOpen}>{children}</Value>
        </OptionStyled>
    );
});

OptionWithValue.defaultProps = {
    title: undefined,
    children: undefined,
    disabled: false
};

OptionWithValue.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.string,
    children: PropTypes.node,
    disabled: PropTypes.bool
};

export default OptionWithValue;
